export { filterPostsByCategories, prioritisePosts } from "./postsHelper"

// CF7 5.4+ requires these hidden meta fields on REST submissions —
// normally added by the [contact-form-7] shortcode, but our custom
// Gatsby forms post to the REST endpoint directly so we add them here.
export const appendCf7Meta = (formData, formUrl) => {
  const match = String(formUrl).match(/\/contact-forms\/(\d+)\//)
  const id = match ? match[1] : ""
  formData.append("_wpcf7", id)
  formData.append("_wpcf7_version", "5.8.7")
  formData.append("_wpcf7_locale", "en_GB")
  formData.append("_wpcf7_unit_tag", `wpcf7-f${id}-o1`)
  formData.append("_wpcf7_container_post", "0")
  return formData
}

export const createLink = url => {

if (!url || url === "#") {
  return "#"
}

  const localSiteUrl = new RegExp(
    `^(${process.env.SITE_URL_PROD}|${process.env.SITE_URL_STAG})`
  )

  if (url.match(localSiteUrl)) {
    return url.replace(localSiteUrl, "").replace("/home/", "/")
  }

  return url
}
